<div class="menu-container" [style.width]="menuWidth">
  <div class="column" *ngFor="let col of columns" [ngClass]="{'visual-column': col.type !== 'list' && col.type !== 'multi-list'}">
    <ng-container *ngIf="col.title">
      <h3 [ngClass]="'title-' + col.titleColor">{{ col.title }}</h3>
      <div [ngClass]="col.titleColor === 'orange' ? 'underline-dark' : 'underline-green'"></div>
    </ng-container>

    <ng-container [ngSwitch]="col.type">
      <div class="list-group" *ngSwitchCase="'list'">
        <ul>
          <li *ngFor="let item of col.items">
            <a *ngIf="isExternalLink(item.lien)" [href]="item.lien" target="_blank">{{ item.label }}</a>
            <a *ngIf="!isExternalLink(item.lien)" [routerLink]="item.lien">{{ item.label }}</a>
          </li>
        </ul>
      </div>

      <div class="multi-list-group" *ngSwitchCase="'multi-list'" [class]="col.className">
        <div *ngFor="let group of col.items" class="sub-group">
          <h4 class="category-title">
            <a [routerLink]="group.lien" (click)="onItemClick()">{{ group.label }}</a>
          </h4>
          <ul>
            <li *ngFor="let sub of group.subItems">
              <a [routerLink]="sub.lien" (click)="onItemClick()">{{ sub.label }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="banners-stack" *ngSwitchCase="'visual-stack'" [ngClass]="col.className">
        <a *ngFor="let item of col.items" [routerLink]="item.lien" class="banner-link">
          <img [src]="item.img" [alt]="item.label" class="img-banner">
          <div class="overlay-hover" *ngIf="item.label"><span>{{ item.label }}</span></div>
        </a>
      </div>

      <div class="visual-grid" *ngSwitchCase="'visual-grid'">
        <a *ngFor="let item of col.items" [routerLink]="item.lien" class="logo-link">
          <img [src]="item.img" [alt]="item.label" class="img-logo" onerror="this.style.display='none';">
        </a>
      </div>
    </ng-container>
  </div>
</div>
